<template>
    <div>
        <v-simple-table dense>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">Producto</th>
                        <th class="text-center" width="8%">Cantidad</th>
                        <th class="text-center" width="8%">Precio</th>
                        <th class="text-center" width="8%">Descuento</th>
                        <th class="text-center" width="16%">Subtotal</th>
                        <th class="text-center" width="5%"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in productos" :key="item.idarticulo" class="text-center">
                        <td class="text-left">{{ item.nombre }}</td>
                        <td>
                            <v-text-field v-model="item.cantidad"  @change="calculos(item)" dense></v-text-field>
                        </td>
                        <td>
                            <v-text-field  v-model="item.precioventa"  @change="calculos(item)" dense></v-text-field>
                        </td>
                        <td class="text-center">
                            <v-text-field class="text-center"  v-model="item.descuento"  @change="calculos(item)"
                                dense></v-text-field>
                        </td>
                        <td>
                            <v-text-field :value="
                                (item.cantidad * item.precioventa - item.descuento)
                                | redondear
                            " dense readonly></v-text-field>
                        </td>

                        <td>
                            <v-btn icon @click="removeItemCart(item)" dense><v-icon
                                    color="red">mdi-close-box</v-icon></v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </div>
</template>
<script>
import Swal from "sweetalert2";
import currency from "@/utils/currency.js";
import {setStorageCarrito} from "../POS/utils/localstorage";


export default {
  props: ["productos"],
  name: "Carrito",
  data: () => ({
    reglas:{
      //numeros: v => !!(v || '').match(/^(?!0+\.00)(?=.{1,9}(\.|$))(?!0(?!\.))\d{1,3}(\d{3})*(\.\d+)?$/) || 'Inválido'
    }
  }),

  methods: {

    removeItemCart(item) {
        
      const index = this.productos.indexOf(item);
      this.productos.splice(index, 1);
      setStorageCarrito(this.productos)
    },

    calculos(item) {
      

        const producto = this.$store.getters.getProductosActivos.find(
            (element) => element.articulo.idarticulo === item.idarticulo
            );
            

      const index = this.productos.indexOf(item);
      //Validamos que la cantidad no supere al stock
      const stockActual = parseFloat(producto.stockactual);

      item.precioventa = currency(item.precioventa,{ precision: 3 })
      //item.precioventa= item.precioventa.replace(".", '.00')
     
     item.total = currency(
            parseFloat(item.cantidad) * parseFloat(item.precioventa) -
              parseFloat(item.descuento),
            { precision: 5 }
          ).value;


      if (producto.articulo.controlstock) {
        //Validamos que tenga controlStock en True

          if ( item.cantidad > stockActual ) {
          
          item.cantidad = parseFloat(producto.stockactual);
            Swal.fire(
              "Cantidad maxima que puede vender es de " + producto.stockactual
            );

          
          } 
      }

      //Validamos que el precio de venta no supere al preciominimo

      if (
        parseFloat(this.productos[index].precioventa) <
        parseFloat(producto.articulo.preciominimo)
      ) {
        item.precioventa = producto.articulo.preciominimo;
        Swal.fire(
          "El precio minimo del producto es Q " + producto.articulo.preciominimo
        );
      }
      if (this.productos[index].descuento.length == 0) {
        item.descuento = 0;
      }
      if (item.cantidad < 0.01) {
        item.cantidad = 1;
      }

      setStorageCarrito(this.productos)
    },
    
  },

  filters: {
    redondear: function (value) {
      if (!value) return "";
      value = parseFloat(value);
      return currency(value, { precision: 2 });
    },
  },
};
</script>
